export const ResourcesDEVX_HE =
    {
        "he":
            {
                "Yes": "כן",
                "No": "לא",
                "Cancel": "בטל",
                "Clear": "נקה",
                "Done": "סיים",
                "Loading": "טוען...",
                "Select": "בחר",
                "Search": "חפש",
                "Back": "חזור",
                "OK": "אישור",

                "dxCollectionWidget-noDataText": "אין נתונים",

                "validation-required": "השדה הינו חובה",
                "validation-required-formatted": "שדה {0} הוא חובה",
                "validation-numeric": "הערך חייב להיות מספר",
                "validation-numeric-formatted": "{0} חייב להיות מספר",
                "validation-range": "הערך מחוץ לתווך שהוגדר",
                "validation-range-formatted": "{0} מחוץ לתווך שהוגדר",
                "validation-stringLength": "האורך לא תקין",
                "validation-stringLength-formatted": "האורך של {0} לא תקין",
                "validation-custom": "הערך לא תקין",
                "validation-custom-formatted": "{0} לא תקין",
                "validation-compare": "הערכים לא זהים",
                "validation-compare-formatted": "{0} לא זהה",
                "validation-pattern": "הערך לא תואם את התבנית שהוגדרה",
                "validation-pattern-formatted": "{0} לא תואם את התבנית שהוגדרה",
                "validation-email": "כתובת אימייל לא חוקית",
                "validation-email-formatted": "{0} הוא כתובת אימייל לא חוקית",
                "validation-mask": "הערך לא תואם בתבנית שהוגדרה",

                "dxLookup-searchPlaceholder": "מספר תווים מינימאלי: {0}",

                "dxList-pullingDownText": "משוך למטה על מנת לרענן...",
                "dxList-pulledDownText": "שחרר לרענן...",
                "dxList-refreshingText": "מרענן...",
                "dxList-pageLoadingText": "טוען...",
                "dxList-nextButtonText": "עוד",
                "dxList-selectAll": "בחר כולם",
                "dxListEditDecorator-delete": "מחק",
                "dxListEditDecorator-more": "עוד",

                "dxScrollView-pullingDownText": "משוך למטה על מנת לרענן...",
                "dxScrollView-pulledDownText": "שחרר לרענן...",
                "dxScrollView-refreshingText": "מרענן...",
                "dxScrollView-reachBottomText": "טוען...",

                "dxDateBox-simulatedDataPickerTitleTime": "בחר שעה",
                "dxDateBox-simulatedDataPickerTitleDate": "בחר תאריך",
                "dxDateBox-simulatedDataPickerTitleDateTime": "בחר תאריך ושעה",
                "dxDateBox-validation-datetime": "הערך חייב להיות תאריך או שעה",

                "dxFileUploader-selectFile": "Select file",
                "dxFileUploader-dropFile": "or Drop file here",
                "dxFileUploader-bytes": "bytes",
                "dxFileUploader-kb": "kb",
                "dxFileUploader-Mb": "Mb",
                "dxFileUploader-Gb": "Gb",
                "dxFileUploader-upload": "Upload",
                "dxFileUploader-uploaded": "Uploaded",
                "dxFileUploader-readyToUpload": "Ready to upload",
                "dxFileUploader-uploadFailedMessage": "Upload failed",
                "dxFileUploader-invalidFileExtension": "File type is not allowed",
                "dxFileUploader-invalidMaxFileSize": "File is too large",
                "dxFileUploader-invalidMinFileSize": "File is too small",

                "dxRangeSlider-ariaFrom": "מ",
                "dxRangeSlider-ariaTill": "עד",
                "dxSwitch-switchedOnText": "דלוק",
                "dxSwitch-switchedOffText": "כבוי",

                "dxForm-optionalMark": "אופציונאלי",
                "dxForm-requiredMessage": "{0} הינו חובה",

                "dxNumberBox-invalidValueMessage": "הערך חייב להיות מספר",

                "dxDataGrid-columnChooserTitle": "בחירת עמודות",
                "dxDataGrid-columnChooserEmptyText": "Drag a column here to hide it",
                "dxDataGrid-groupContinuesMessage": "Continues on the next page",
                "dxDataGrid-groupContinuedMessage": "Continued from the previous page",
                "dxDataGrid-groupHeaderText": "קבץ לפי עמודה זו",
                "dxDataGrid-ungroupHeaderText": "בטל קיבוץ",
                "dxDataGrid-ungroupAllText": "בטל קיבוץ עמודות",
                "dxDataGrid-editingEditRow": "ערוך",
                "dxDataGrid-editingSaveRowChanges": "שמור שינויים",
                "dxDataGrid-editingCancelRowChanges": "בטל",
                "dxDataGrid-editingDeleteRow": "Delete",
                "dxDataGrid-editingUndeleteRow": "Undelete",
                "dxDataGrid-editingConfirmDeleteMessage": "האם אתה בטוח שברצונך למחוק רשומה זו?",
                "dxDataGrid-validationCancelChanges": "בטל שינוים",
                "dxDataGrid-groupPanelEmptyText": "גרור עמודה לכאן על מנת לקבץ לפיה",
                "dxDataGrid-noDataText": "אין נתונים",
                "dxDataGrid-searchPanelPlaceholder": "חפש",
                "dxDataGrid-filterRowShowAllText": "(All)",
                "dxDataGrid-filterRowResetOperationText": "Reset",
                "dxDataGrid-filterRowOperationEquals": "Equals",
                "dxDataGrid-filterRowOperationNotEquals": "Does not equal",
                "dxDataGrid-filterRowOperationLess": "Less than",
                "dxDataGrid-filterRowOperationLessOrEquals": "Less than or equal to",
                "dxDataGrid-filterRowOperationGreater": "Greater than",
                "dxDataGrid-filterRowOperationGreaterOrEquals": "Greater than or equal to",
                "dxDataGrid-filterRowOperationStartsWith": "Starts with",
                "dxDataGrid-filterRowOperationContains": "Contains",
                "dxDataGrid-filterRowOperationNotContains": "Does not contain",
                "dxDataGrid-filterRowOperationEndsWith": "Ends with",
                "dxDataGrid-filterRowOperationBetween": "Between",
                "dxDataGrid-filterRowOperationBetweenStartText": "Start",
                "dxDataGrid-filterRowOperationBetweenEndText": "End",
                "dxDataGrid-applyFilterText": "Apply filter",
                "dxDataGrid-trueText": "כן",
                "dxDataGrid-falseText": "לא",
                "dxDataGrid-sortingAscendingText": "מיין בסדר עולה",
                "dxDataGrid-sortingDescendingText": "מיין בסדר יורד",
                "dxDataGrid-sortingClearText": "אפס מיון",
                "dxDataGrid-editingSaveAllChanges": "שמור שינויים",
                "dxDataGrid-editingCancelAllChanges": "בטל שינויים",
                "dxDataGrid-editingAddRow": "הוסף רשומה",
                "dxDataGrid-summaryMin": "Min: {0}",
                "dxDataGrid-summaryMinOtherColumn": "Min of {1} is {0}",
                "dxDataGrid-summaryMax": "Max: {0}",
                "dxDataGrid-summaryMaxOtherColumn": "Max of {1} is {0}",
                "dxDataGrid-summaryAvg": "Avg: {0}",
                "dxDataGrid-summaryAvgOtherColumn": "Avg of {1} is {0}",
                "dxDataGrid-summarySum": "Sum: {0}",
                "dxDataGrid-summarySumOtherColumn": "Sum of {1} is {0}",
                "dxDataGrid-summaryCount": "Count: {0}",
                "dxDataGrid-columnFixingFix": "Fix",
                "dxDataGrid-columnFixingUnfix": "Unfix",
                "dxDataGrid-columnFixingLeftPosition": "To the left",
                "dxDataGrid-columnFixingRightPosition": "To the right",
                "dxDataGrid-exportTo": "Export",
                "dxDataGrid-exportToExcel": "Export to Excel file",
                "dxDataGrid-excelFormat": "Excel file",
                "dxDataGrid-selectedRows": "Selected rows",
                "dxDataGrid-exportSelectedRows": "Export selected rows",
                "dxDataGrid-exportAll": "Export all data",
                "dxDataGrid-headerFilterEmptyValue": "(ריקים)",
                "dxDataGrid-headerFilterOK": "אישור",
                "dxDataGrid-headerFilterCancel": "ביטול",
                "dxDataGrid-ariaColumn": "Column",
                "dxDataGrid-ariaValue": "Value",
                "dxDataGrid-ariaFilterCell": "Filter cell",
                "dxDataGrid-ariaCollapse": "Collapse",
                "dxDataGrid-ariaExpand": "Expand",
                "dxDataGrid-ariaDataGrid": "Data grid",
                "dxDataGrid-ariaSearchInGrid": "Search in data grid",
                "dxDataGrid-ariaSelectAll": "Select all",
                "dxDataGrid-ariaSelectRow": "Select row",
                "dxDataGrid-filterBuilderPopupTitle": "Filter Builder",
                "dxDataGrid-filterPanelCreateFilter": "Create Filter",
                "dxDataGrid-filterPanelClearFilter": "Clear",
                "dxDataGrid-filterPanelFilterEnabledHint": "Enable the filter",

                "dxTreeList-ariaTreeList": "Tree list",
                "dxTreeList-editingAddRowToNode": "Add",

                "dxPager-infoText": "Page {0} of {1} ({2} items)",
                "dxPager-pagesCountText": "of",

                "dxPivotGrid-grandTotal": "Grand Total",
                "dxPivotGrid-total": "{0} Total",
                "dxPivotGrid-fieldChooserTitle": "Field Chooser",
                "dxPivotGrid-showFieldChooser": "Show Field Chooser",
                "dxPivotGrid-expandAll": "Expand All",
                "dxPivotGrid-collapseAll": "Collapse All",
                "dxPivotGrid-sortColumnBySummary": "Sort \"{0}\" by This Column",
                "dxPivotGrid-sortRowBySummary": "Sort \"{0}\" by This Row",
                "dxPivotGrid-removeAllSorting": "Remove All Sorting",
                "dxPivotGrid-dataNotAvailable": "N/A",
                "dxPivotGrid-rowFields": "Row Fields",
                "dxPivotGrid-columnFields": "Column Fields",
                "dxPivotGrid-dataFields": "Data Fields",
                "dxPivotGrid-filterFields": "Filter Fields",
                "dxPivotGrid-allFields": "All Fields",
                "dxPivotGrid-columnFieldArea": "Drop Column Fields Here",
                "dxPivotGrid-dataFieldArea": "Drop Data Fields Here",
                "dxPivotGrid-rowFieldArea": "Drop Row Fields Here",
                "dxPivotGrid-filterFieldArea": "Drop Filter Fields Here",

                "dxScheduler-editorLabelTitle": "Subject",
                "dxScheduler-editorLabelStartDate": "Start Date",
                "dxScheduler-editorLabelEndDate": "End Date",
                "dxScheduler-editorLabelDescription": "Description",
                "dxScheduler-editorLabelRecurrence": "Repeat",

                "dxScheduler-openAppointment": "Open appointment",

                "dxScheduler-recurrenceNever": "Never",
                "dxScheduler-recurrenceDaily": "Daily",
                "dxScheduler-recurrenceWeekly": "Weekly",
                "dxScheduler-recurrenceMonthly": "Monthly",
                "dxScheduler-recurrenceYearly": "Yearly",

                "dxScheduler-recurrenceEvery": "Every",
                "dxScheduler-recurrenceEnd": "End repeat",
                "dxScheduler-recurrenceAfter": "After",
                "dxScheduler-recurrenceOn": "On",

                "dxScheduler-recurrenceRepeatDaily": "day(s)",
                "dxScheduler-recurrenceRepeatWeekly": "week(s)",
                "dxScheduler-recurrenceRepeatMonthly": "month(s)",
                "dxScheduler-recurrenceRepeatYearly": "year(s)",

                "dxScheduler-switcherDay": "Day",
                "dxScheduler-switcherWeek": "Week",
                "dxScheduler-switcherWorkWeek": "Work Week",
                "dxScheduler-switcherMonth": "Month",

                "dxScheduler-switcherAgenda": "Agenda",

                "dxScheduler-switcherTimelineDay": "Timeline Day",
                "dxScheduler-switcherTimelineWeek": "Timeline Week",
                "dxScheduler-switcherTimelineWorkWeek": "Timeline Work Week",
                "dxScheduler-switcherTimelineMonth": "Timeline Month",

                "dxScheduler-recurrenceRepeatOnDate": "on date",
                "dxScheduler-recurrenceRepeatCount": "occurrence(s)",
                "dxScheduler-allDay": "All day",

                "dxScheduler-confirmRecurrenceEditMessage": "Do you want to edit only this appointment or the whole series?",
                "dxScheduler-confirmRecurrenceDeleteMessage": "Do you want to delete only this appointment or the whole series?",

                "dxScheduler-confirmRecurrenceEditSeries": "Edit series",
                "dxScheduler-confirmRecurrenceDeleteSeries": "Delete series",
                "dxScheduler-confirmRecurrenceEditOccurrence": "Edit appointment",
                "dxScheduler-confirmRecurrenceDeleteOccurrence": "Delete appointment",

                "dxScheduler-noTimezoneTitle": "No timezone",
                "dxScheduler-moreAppointments": "{0} more",

                "dxCalendar-todayButtonText": "Today",
                "dxCalendar-ariaWidgetName": "Calendar",

                "dxColorView-ariaRed": "אדום",
                "dxColorView-ariaGreen": "ירוק",
                "dxColorView-ariaBlue": "כחול",
                "dxColorView-ariaAlpha": "שקיפות",
                "dxColorView-ariaHex": "קוד צבע",

                "dxTagBox-selected": "{0} נבחר",
                "dxTagBox-allSelected": "הכל נבחר ({0})",
                "dxTagBox-moreSelected": "{0} עוד",

                "vizExport-printingButtonText": "Print",
                "vizExport-titleMenuText": "Exporting/Printing",
                "vizExport-exportButtonText": "{0} file",

                "dxFilterBuilder-and": "And",
                "dxFilterBuilder-or": "Or",
                "dxFilterBuilder-notAnd": "Not And",
                "dxFilterBuilder-notOr": "Not Or",
                "dxFilterBuilder-addCondition": "Add Condition",
                "dxFilterBuilder-addGroup": "Add Group",
                "dxFilterBuilder-enterValueText": "<enter a value>",
                "dxFilterBuilder-filterOperationEquals": "Equals",
                "dxFilterBuilder-filterOperationNotEquals": "Does not equal",
                "dxFilterBuilder-filterOperationLess": "Is less than",
                "dxFilterBuilder-filterOperationLessOrEquals": "Is less than or equal to",
                "dxFilterBuilder-filterOperationGreater": "Is greater than",
                "dxFilterBuilder-filterOperationGreaterOrEquals": "Is greater than or equal to",
                "dxFilterBuilder-filterOperationStartsWith": "Starts with",
                "dxFilterBuilder-filterOperationContains": "Contains",
                "dxFilterBuilder-filterOperationNotContains": "Does not contain",
                "dxFilterBuilder-filterOperationEndsWith": "Ends with",
                "dxFilterBuilder-filterOperationIsBlank": "Is blank",
                "dxFilterBuilder-filterOperationIsNotBlank": "Is not blank",
                "dxFilterBuilder-filterOperationBetween": "Is between",
                "dxFilterBuilder-filterOperationAnyOf": "Is any of",
                "dxFilterBuilder-filterOperationNoneOf": "Is none of",

                "dxHtmlEditor-dialogColorCaption": "Change Font Color",
                "dxHtmlEditor-dialogBackgroundCaption": "Change Background Color",
                "dxHtmlEditor-dialogLinkCaption": "Add Link",
                "dxHtmlEditor-dialogLinkUrlField": "URL",
                "dxHtmlEditor-dialogLinkTextField": "Text",
                "dxHtmlEditor-dialogLinkTargetField": "Open link in new window",
                "dxHtmlEditor-dialogImageCaption": "Add Image",
                "dxHtmlEditor-dialogImageUrlField": "URL",
                "dxHtmlEditor-dialogImageAltField": "Alternate text",
                "dxHtmlEditor-dialogImageWidthField": "Width (px)",
                "dxHtmlEditor-dialogImageHeightField": "Height (px)",
                "dxHtmlEditor-heading": "Heading",
                "dxHtmlEditor-normalText": "Normal text"
            }
    }
